import axios from "axios";
import config from "../../config";

const axiosPublic = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
    },
    baseURL: config.BASE_URL,
});
export default axiosPublic;